import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, IconButton, Breadcrumbs, Link, Typography, Tooltip, Paper } from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Home as HomeIcon,
  CloudUpload as UploadIcon,
  Gavel as ValidateIcon,
  Person as ProfileIcon,
} from '@mui/icons-material';

function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const pathMap = {
    '/': 'Home',
    '/upload': 'Upload Content',
    '/validate': 'Validate Content',
    '/profile': 'Profile',
  };

  const iconMap = {
    '/': <HomeIcon fontSize="small" />,
    '/upload': <UploadIcon fontSize="small" />,
    '/validate': <ValidateIcon fontSize="small" />,
    '/profile': <ProfileIcon fontSize="small" />,
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleNavigate = path => {
    navigate(path);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        mb: 3,
        background:
          'linear-gradient(135deg, rgba(156, 39, 176, 0.1) 0%, rgba(156, 39, 176, 0.05) 100%)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(156, 39, 176, 0.2)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          p: 2,
        }}
      >
        {location.pathname !== '/' && (
          <Tooltip
            title="Go Back"
            sx={{
              '& .MuiTooltip-tooltip': {
                background: 'rgba(156, 39, 176, 0.9)',
                color: '#fff',
              },
            }}
          >
            <IconButton
              onClick={handleBack}
              sx={{
                mr: 2,
                color: 'primary.light',
                '&:hover': {
                  background: 'rgba(156, 39, 176, 0.1)',
                },
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          </Tooltip>
        )}

        <Breadcrumbs
          separator="›"
          aria-label="navigation"
          sx={{
            '& .MuiBreadcrumbs-separator': {
              color: 'primary.light',
            },
          }}
        >
          {Object.entries(pathMap).map(([path, label]) => (
            <Link
              key={path}
              component="button"
              onClick={() => handleNavigate(path)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                color: location.pathname === path ? 'primary.light' : 'text.secondary',
                textDecoration: 'none',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px 8px',
                borderRadius: '8px',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  background: 'rgba(156, 39, 176, 0.1)',
                  color: 'primary.light',
                  transform: 'translateY(-1px)',
                },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                }}
              >
                {iconMap[path]}
                <Typography>{label}</Typography>
              </Box>
            </Link>
          ))}
        </Breadcrumbs>
      </Box>
    </Paper>
  );
}

export default Navigation;
